import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TestC = () => /*#__PURE__*/_jsx("div", {
  children: "testc"
});